import { render, staticRenderFns } from "./SelectOption.vue?vue&type=template&id=55b53f2c&"
import script from "./SelectOption.vue?vue&type=script&lang=ts&"
export * from "./SelectOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sush/Virtual/cublic-form-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55b53f2c')) {
      api.createRecord('55b53f2c', component.options)
    } else {
      api.reload('55b53f2c', component.options)
    }
    module.hot.accept("./SelectOption.vue?vue&type=template&id=55b53f2c&", function () {
      api.rerender('55b53f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resource/component/form/Field/SelectOption.vue"
export default component.exports